import optionsHelper from '../../optionsHelper';
import bankgirotLogoAsDataImageHelper from '../../bankgirotLogoAsDataImageHelper';
import countrySettingsForGoCardless from '../../../config/countrySettingsForGoCardless';
import fieldHelper from '../../fieldHelper';
import defaults from '../../../config/fieldDefaults';

let goCardlessDataConfirmed = false;
let goCardlessUseLocalDetails = false;
let goCardlessInformations;
let goCardlessToggleIbanOrLocalDetailsIntervalId;
let checkLoadedIframesIntervalId;
let goCardlessSelectedCountryCode;
const goCardlessFormDataForModal = {};
const originalLabels = {};
let changedLabels = {};

let config = {};
let loaded = false;

const init = (cfg) => {
  config = cfg;
};

const unload = () => {
  if (!loaded) return;

  goCardlessUseLocalDetails = false;

  window.clearInterval(goCardlessToggleIbanOrLocalDetailsIntervalId);
  window.clearInterval(checkLoadedIframesIntervalId);

  if (config.globalUserOptions.selectorForToggleIbanOrLocalDetails) {
    window.removeEventListener('click', handleClickToToggleLocalDetailsOrIban, false);
  }

  if (config.globalUserOptions.selectorForGoCardlessHeader) {
    const elemForGoCardlessHeader = document.querySelector(config.globalUserOptions.selectorForGoCardlessHeader);

    if (elemForGoCardlessHeader != null) {
      elemForGoCardlessHeader.innerHTML = '';
    }
  }

  if (config.globalUserOptions.selectorForGoCardlessFooter) {
    const elemForGoCardlessFooter = document.querySelector(config.globalUserOptions.selectorForGoCardlessFooter);

    if (elemForGoCardlessFooter != null) {
      elemForGoCardlessFooter.innerHTML = '';
    }
  }

  if (config.globalUserOptions.selectorForToggleIbanOrLocalDetails) {
    const elemGoCardlessToggleIbanOrLocalDetails = document.querySelector(config.globalUserOptions.selectorForToggleIbanOrLocalDetails);

    if (elemGoCardlessToggleIbanOrLocalDetails != null) {
      elemGoCardlessToggleIbanOrLocalDetails.innerHTML = '';
    }
  }
};

const initGoCardless = () => {
  loaded = true;
  addGoCardlessToogleIbanOrLocalDetails();
  addGoCardlessHeader();
  addGoCardlessFooter();
  hideLocalDetailsFields();

  if (config.globalUserOptions.selectorForToggleIbanOrLocalDetails) {
    window.addEventListener('click', handleClickToToggleLocalDetailsOrIban, false);
  }
};

const addGoCardlessToogleIbanOrLocalDetails = () => {
  const elemGoCardlessToogleIbanOrLocalDetails = document.querySelector(config.globalUserOptions.selectorForToggleIbanOrLocalDetails);

  if (elemGoCardlessToogleIbanOrLocalDetails == null) {
    return;
  }

  const toggleIBanOrLocalDetailsDiv = document.createElement('div');
  toggleIBanOrLocalDetailsDiv.id = 'local-details-or-iban';
  toggleIBanOrLocalDetailsDiv.className = 'gocardless-toggle-iban-or-local-details';
  toggleIBanOrLocalDetailsDiv.innerHTML = '<a href="#" id="toggle-local-details-or-iban">or enter local details</a>';

  elemGoCardlessToogleIbanOrLocalDetails.appendChild(toggleIBanOrLocalDetailsDiv);
};

const addGoCardlessHeader = () => {
  let header = 'Set up a ';

  if (goCardlessInformations.direct_debit_scheme === 'pad') {
    header += 'Pre-Authorized Debit';
  } else if (goCardlessInformations.direct_debit_scheme === 'becs') {
    header += 'Direct Debit Request';
  } else if (goCardlessInformations.direct_debit_scheme === 'becs_nz') {
    header += 'Direct Debit Instruction';
  } else {
    header += 'Direct Debit';
  }

  header += ` with ${goCardlessInformations.first_creditor_name}`;

  const elemForGoCardlessHeader = document.querySelector(config.globalUserOptions.selectorForGoCardlessHeader);

  if (elemForGoCardlessHeader == null) {
    return;
  }

  const headerDiv = document.createElement('div');
  headerDiv.className = 'gocardless-header';
  headerDiv.innerHTML = header;
  elemForGoCardlessHeader.appendChild(headerDiv);
};

const addGoCardlessFooter = () => {
  let footer = 'Payments by GoCardless. Read the <a href="https://gocardless.com/legal/privacy/" target="_blank">GoCardless privacy notice</a>';

  if (goCardlessInformations.direct_debit_scheme === 'autogiro') {
    footer += `<img src="${bankgirotLogoAsDataImageHelper.getDataImage()}" style="float: right" />`;
  }

  footer += '<br>';

  if (goCardlessInformations.direct_debit_scheme === 'bacs') {
    footer += 'Your payments are protected by the <a href="https://gocardless.com/direct-debit/guarantee/" target="_blank">Direct Debit Guarantee</a><br>';
  }

  footer += '<br>';

  if (goCardlessInformations.direct_debit_scheme === 'pad') {
    footer += `${goCardlessInformations.credentials_email} | ${goCardlessInformations.direct_debit_scheme_phone_number}`;
  } else {
    if (goCardlessInformations.direct_debit_scheme === 'autogiro') {
      footer += `${goCardlessInformations.credentials_email} | ${goCardlessInformations.direct_debit_scheme_phone_number} `;
    }

    footer += `${goCardlessInformations.direct_debit_scheme_name}<br>`;
    footer += `${goCardlessInformations.direct_debit_scheme_address_line1} ${goCardlessInformations.direct_debit_scheme_address_line2}`;
    footer += ` ${goCardlessInformations.direct_debit_scheme_city}<br>`;
    footer += `${goCardlessInformations.direct_debit_scheme_email} | ${goCardlessInformations.direct_debit_scheme_phone_number}<br/>`;
    footer += `Reference: ${goCardlessInformations.direct_debit_scheme_reference}`;
  }

  footer += '<br>';

  const elemForGoCardlessFooter = document.querySelector(config.globalUserOptions.selectorForGoCardlessFooter);

  if (elemForGoCardlessFooter == null) {
    return;
  }

  const footerDiv = document.createElement('div');
  footerDiv.className = 'gocardless-footer';
  footerDiv.innerHTML = footer;
  elemForGoCardlessFooter.appendChild(footerDiv);
};

const receivedGoCardlessData = async (data) => {
  goCardlessInformations = data;
  config.globalUserOptions = optionsHelper.getNormalizedOptions(config.loadUserOptions);
  config.primaryIframeSelector = optionsHelper.getPrimaryIframeSelector(config.globalUserOptions);
  config.sendMessageToMainIframe({ action: 'GO_CARDLESS_INFO', data: data });

  initGoCardlessFormDataForModal();
  await config.createIframes();
  initGoCardless();
};

const initGoCardlessFormDataForModal = () => {
  Object.keys(config.globalUserOptions.fields).forEach((fieldName) => {
    goCardlessFormDataForModal[fieldName] = '';
  });
};

const disableIbanInput = () => {
  goCardlessUseLocalDetails = true;
  hideIbanField();
  hideToggleIbanOrLocalDetailsLink();
  showLocalDetailsFields();
};

const handleClickToToggleLocalDetailsOrIban = (event) => {
  if (!event.target.matches('#toggle-local-details-or-iban')) return;

  event.preventDefault();
  toggleIbanOrLocalDetailsFields();
};

const toggleIbanOrLocalDetailsFields = () => {
  goCardlessUseLocalDetails = !goCardlessUseLocalDetails;
  showIbanOrLocalDetailsFields();
};

const showIbanOrLocalDetailsFields = () => {
  if (goCardlessUseLocalDetails) {
    hideIbanField();
    showLocalDetailsFields();
  } else {
    hideLocalDetailsFields();
    showIbanField();
  }
};

const showIbanField = () => {
  if (config.globalUserOptions.selectorForToggleIbanOrLocalDetails) {
    const linkField = document.querySelector('a#toggle-local-details-or-iban');
    linkField.innerHTML = 'or enter local details';
  } else {
    config.sendMessageToAllFields({ action: 'CHANGE_TOGGLE_LOCAL_DETAILS_OR_IBAN_LINK_NAME', data: 'or enter local details' });
  }

  config.sendMessageToAllFields({ action: 'SHOW_FIELDS', data: ['bankIban'] });
};

const hideIbanField = () => {
  if (config.globalUserOptions.selectorForToggleIbanOrLocalDetails) {
    const linkField = document.querySelector('a#toggle-local-details-or-iban');
    linkField.innerHTML = 'or enter IBAN';
  } else {
    config.sendMessageToAllFields({ action: 'CHANGE_TOGGLE_LOCAL_DETAILS_OR_IBAN_LINK_NAME', data: 'or enter IBAN' });
  }

  config.sendMessageToAllFields({ action: 'HIDE_FIELDS', data: ['bankIban'] });
};

const showLocalDetailsFields = () => {
  let disableFieldsForCountryCode = [];
  const fieldsToShow = ['branchCode', 'routingNumber', 'accountNumber', 'accountType'];

  if (
    goCardlessSelectedCountryCode &&
    Object.prototype.hasOwnProperty.call(countrySettingsForGoCardless, goCardlessSelectedCountryCode) &&
    Object.prototype.hasOwnProperty.call(countrySettingsForGoCardless[goCardlessSelectedCountryCode], 'disabledFields')
  ) {
    disableFieldsForCountryCode = countrySettingsForGoCardless[goCardlessSelectedCountryCode].disabledFields;
  }

  const showFields = [];
  fieldsToShow.forEach((fieldName) => {
    if (disableFieldsForCountryCode.indexOf(fieldName) === -1) {
      showFields.push(fieldName);
    }
  });

  config.sendMessageToAllFields({ action: 'SHOW_FIELDS', data: showFields });
};

const hideLocalDetailsFields = () => {
  config.sendMessageToAllFields({ action: 'HIDE_FIELDS', data: ['branchCode', 'routingNumber', 'accountNumber', 'accountType'] });
};

const hideToggleIbanOrLocalDetailsLink = () => {
  if (config.globalUserOptions.selectorForToggleIbanOrLocalDetails) {
    fieldHelper.hide(document.querySelector('#local-details-or-iban'));
  } else {
    config.sendMessageToAllFields({ action: 'HIDE_TOGGLE_IBAN_OR_LOCAL_DETAILS_LINK' });
  }
};

const handleGoCardlessSettingsForCountryCode = (countryCode) => {
  goCardlessSelectedCountryCode = countryCode;

  restoreOriginalLabels();
  showIbanOrLocalDetailsFields();

  if (!Object.prototype.hasOwnProperty.call(countrySettingsForGoCardless, countryCode)) {
    return;
  }

  if (Object.prototype.hasOwnProperty.call(countrySettingsForGoCardless[countryCode], 'disabledFields')) {
    countrySettingsForGoCardless[countryCode].disabledFields.forEach((disableFieldName) => {
      config.sendMessageToAllFields({ action: 'HIDE_FIELDS', data: [disableFieldName] });
    });
  }

  if (Object.prototype.hasOwnProperty.call(countrySettingsForGoCardless[countryCode], 'changeLabels')) {
    Object.keys(countrySettingsForGoCardless[countryCode].changeLabels).forEach((fieldName) => {
      let label = countrySettingsForGoCardless[countryCode].changeLabels[fieldName];

      if (config.globalUserOptions.addRequiredSignToTranslatedLabels) {
        label += " *";
      }

      changeFieldLabel(fieldName, label);
    });
  }

  if (
    Object.prototype.hasOwnProperty.call(countrySettingsForGoCardless[countryCode], 'onlyLocalDetails') &&
    countrySettingsForGoCardless[countryCode].onlyLocalDetails
  ) {
    disableIbanInput();
  }
};

const changeFieldLabel = (fieldName, label) => {
  if (!Object.prototype.hasOwnProperty.call(originalLabels, fieldName) && config.globalUserOptions.fields[fieldName]) {
    originalLabels[fieldName] = {
      label: config.globalUserOptions.fields[fieldName].label,
      message: config.globalUserOptions.fields[fieldName].message || `${config.globalUserOptions.fields[fieldName].label} is invalid.`,
    };
  }

  changedLabels[fieldName] = label;
  config.sendMessageToAllFields({ action: 'CHANGE_LABEL', data: { fieldName: fieldName, label: label, message: `${label} is invalid.` } });
};

const restoreOriginalLabels = () => {
  Object.keys(originalLabels).forEach((fieldName) => {
    config.sendMessageToAllFields({
      action: 'CHANGE_LABEL',
      data: { fieldName: fieldName, label: originalLabels[fieldName].label, message: originalLabels[fieldName].message },
    });
  });

  changedLabels = {};
};

const hideIframe = (iframeSelector) => {
  if (parent.document.querySelector(iframeSelector).getAttribute('data-iframe-width') == null) {
    parent.document.querySelector(iframeSelector).setAttribute('data-iframe-width', window.getComputedStyle(parent.document.querySelector(iframeSelector).querySelector('iframe')).width);
  }

  parent.document.querySelector(iframeSelector).style.display = 'none';
};

const showIframe = (iframeSelector) => {
  parent.document.querySelector(iframeSelector).querySelector('iframe').style.width = parent.document.querySelector(iframeSelector).getAttribute('data-iframe-width');
  parent.document.querySelector(iframeSelector).style.display = 'block';
};

const setGoCardlessFormDataForModal = (data) => {
  Object.keys(data).forEach((fieldName) => {
    goCardlessFormDataForModal[fieldName] = data[fieldName];
  });
};

const goCardlessDataNotConfirmed = () => !goCardlessDataConfirmed;

const noGoCardlessInformations = () => !goCardlessInformations;

const handleGoCardlessIntiToggleIbanOrLocal = () => {
  goCardlessToggleIbanOrLocalDetailsIntervalId = window.setInterval(() => {
    if (document.querySelector('#toggle-local-details-or-iban')) {
      document.querySelector('#toggle-local-details-or-iban').addEventListener('click', (e) => {
        handleClickToToggleLocalDetailsOrIban(e);
      });
      window.clearInterval(goCardlessToggleIbanOrLocalDetailsIntervalId);
    }
  }, 300);
};

const setGoCardlessDataConfirmed = value => goCardlessDataConfirmed = value;

const countriesForGoCardlessScheme = () => {
  if (!goCardlessInformations) return [];

  return defaults.gocardless.country[goCardlessInformations.direct_debit_scheme].options;
};

const fieldsForGoCardless = () => {
  if (!goCardlessInformations) return {};

  return config.globalUserOptions.fields;
};

const goCardlessDirectDebitScheme = () => {
  if (!goCardlessInformations) return;

  return goCardlessInformations.direct_debit_scheme;
};

const goCardlessCurrentConfig = () => {
  return {
    goCardlessUseLocalDetails: goCardlessUseLocalDetails,
    changedLabels: changedLabels,
    goCardlessSelectedCountryCode: goCardlessSelectedCountryCode,
  };
};

const internalFunctions = {
  countries: countriesForGoCardlessScheme,
  countrySettings: () => countrySettingsForGoCardless,
  handleSettingsForCountryCode: handleGoCardlessSettingsForCountryCode,
  toggleIbanOrLocalDetailsFields,
  fields: fieldsForGoCardless,
  directDebitScheme: goCardlessDirectDebitScheme,
  fieldValues: goCardlessFormDataForModal,
};

export default {
  init,
  unload,
  receivedGoCardlessData,
  toggleIbanOrLocalDetailsFields,
  handleGoCardlessSettingsForCountryCode,
  handleGoCardlessIntiToggleIbanOrLocal,
  setGoCardlessFormDataForModal,
  hideIframe,
  showIframe,
  goCardlessDataNotConfirmed,
  noGoCardlessInformations,
  setGoCardlessDataConfirmed,
  goCardlessCurrentConfig,
  internalFunctions,
};
